import { PagedFilter, GeoLocation } from '../../common/common.types';
import { MetaStatus } from '../meta.types';

export class EventBaseFilter extends PagedFilter {
	searchTerm?: string;
	statuses?: MetaStatus[];
}

export class EventBase {
	eventBaseId: number;
	name: string;
	currencyCode: string;
	timezone: string;
	location: GeoLocation;
	status: MetaStatus;
}

export class NewEventBase {
	name: string;
	currencyCode: string;
	timezone: string;
	location: GeoLocation;
}

export class UpdatedEventBase {
	name: string;
	currencyCode: string;
	timezone: string;
	location: GeoLocation;
}
